import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/core/Button';
import { Image } from 'components/core/Image';

import mapWithPinIcon from 'assets/images/icons/map-with-pin.svg';
import './ViewMapButton.scss';

export function ViewMapButton({ onClick, text }) {
	return (
		<Button
			className="view-map-outline-button"
			onClick={onClick}
			outline
		>
			<Image className="map-with-pin" src={mapWithPinIcon} alt="map with pin" />
			<span>{text}</span>
		</Button>
	);
}

ViewMapButton.propTypes = {
	onClick: PropTypes.func,
	text: PropTypes.string
};

export default ViewMapButton;
